var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M9 7.2V16.79C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2H14.2C11 2 9 4 9 7.2Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.56945 8.11953L2.21945 11.4695C1.92945 11.7595 1.92945 12.2395 2.21945 12.5295L5.56945 15.8795C5.85945 16.1695 6.33945 16.1695 6.62945 15.8795C6.91945 15.5895 6.91945 15.1095 6.62945 14.8195L4.55945 12.7495H15.2495C15.6595 12.7495 15.9995 12.4095 15.9995 11.9995C15.9995 11.5895 15.6595 11.2495 15.2495 11.2495H4.55945L6.62945 9.17953C6.77945 9.02953 6.84945 8.83953 6.84945 8.64953C6.84945 8.45953 6.77945 8.25953 6.62945 8.11953C6.33945 7.81953 5.86945 7.81953 5.56945 8.11953Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7aff1fabcee55928922a198eb24e055e.svg";
export { ForwardRef as ReactComponent };